import { putAccessGrant } from "@/shared/infrastructure/adapters/filterAdapter";
/**
 * errorCode -> i18n key for a refused grant write: the BFF's grantee checks (`Sharing.GranteeId.*`) and opref's
 * refusal to share a non-Personal filter. Renaming a code on either side silently falls back to the generic message.
 */
export const SHARING_ERROR_KEYS = {
    "Sharing.GranteeId.NotInOrganization": "advancedFilterLibrary.access.manage.errors.granteeNotInOrganization",
    "Sharing.GranteeId.LookupUnavailable": "advancedFilterLibrary.access.manage.errors.lookupUnavailable",
    "SavedFilter.Visibility.NotShareable": "advancedFilterLibrary.access.manage.errors.notShareable",
};
export function useSavedFilterSharing() {
    // Sequential, and a failure does not stop the remaining requests: each PUT is an
    // independent grant, so one rejected grantee must not leave the others unshared.
    async function applyRequests(id, requests) {
        let grants = null;
        const failures = [];
        for (const request of requests) {
            try {
                grants = await putAccessGrant(id, request);
            }
            catch (e) {
                failures.push(e);
            }
        }
        return { grants, failures };
    }
    return { applyRequests };
}
